import React from 'react'
import { Box, Typography } from '@mui/material'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { InputButton, InputText } from '../../../Simple'
import { LuClipboardPenLine } from 'react-icons/lu'
import { semFoto, starAnimated, notConfig, notAgend } from '../../../../assets'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import BlockIcon from '@mui/icons-material/Block'
import { isSuperAvaliado } from '../../../../utils'
import { AuthContext } from '../../../../contexts/AuthContext'
import RouterHook from '../../../../contexts/RouterHook'
import { ChatContext } from '../../../../contexts/ChatContext'
import { IoChatbubbles } from 'react-icons/io5'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { Services } from '../../../../services'
import Lottie from 'lottie-react'

export default function NoAccess() {
  const serverRouter = RouterHook()

  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = React.useContext(EmpresasContext)
  const { actionsChatCtx } = React.useContext(ChatContext)

  const [solAcesso, setSolAcesso] = React.useState('')

  const emp = sttPg.empresa
  const [urlImagem, setUrlImagem] = React.useState(emp.urlFoto + emp.foto)
  //console.log('SttPg', sttPg)
  React.useEffect(() => {
    const img = new Image()
    img.src = urlImagem
    img.onload = () => {}
    img.onerror = () => {
      setUrlImagem(semFoto)
    }
  }, [urlImagem])

  return (
    <div
      style={{
        height: '25vh',
        backgroundImage: `url(${urlImagem})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {isSuperAvaliado(emp) && (
        <Lottie
          animationData={starAnimated}
          loop={false}
          style={{
            width: '50px',
            height: '50px',
            position: 'absolute',
            top: '21vh',
            right: '2vh',
            zIndex: 1,
          }}
        />
      )}
      <Box
        sx={{
          borderRadius: 6,
          mt: '22vh',
          overflow: 'hidden',
          backgroundColor: 'white',
          width: '100%',
        }}
      >
        <Box sx={{ padding: 2 }}>
          <Typography color='black' variant='h6' fontFamily='integral-cf-bold'>
            {emp.nome}
          </Typography>
          <Typography color={'gray'} variant='body1'>
            {emp.descricao}
          </Typography>
        </Box>
      </Box>

      {sttPg.modePg === 'config' ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img
            src={notConfig}
            alt='Centro esportivo não configurado'
            style={{ width: '100px', height: 'auto', marginTop: '10dvh' }}
          />
          <Typography
            variant='h6'
            fontWeight='bold'
            color='black'
            fontFamily='integral-cf-bold'
            sx={{ mt: 1 }}
          >
            EM PREPARAÇÃO
          </Typography>
          <Typography variant='body1' align='center' color='gray' sx={{ my: 1 }}>
            {emp.nome} está sendo preparada e em breve estará disponível para receber agendamentos
          </Typography>
          <Typography variant='body1' align='center' color='gray' sx={{ my: 1 }}>
            Você pode mandar uma mensagem direta para o centro esportivo manifestando seu interesse
            em agendar
          </Typography>
          <InputButton
            fullWidth
            variant='contained'
            startIcon={<IoChatbubbles size={25} />}
            onClick={() => {
              actionsChatCtx.AbrirChatDireto(emp.idempresa)
              serverRouter('chat', userUCtx.usuario.idusuario)
            }}
          >
            Mensagem Direta
          </InputButton>
        </Box>
      ) : !sttAuthCtx.isLogged ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <LockOutlinedIcon color='primary' sx={{ fontSize: 50, mb: 1 }} />
          <Typography variant='h6' fontWeight='bold' sx={{ mb: 1 }}>
            Entre com sua conta
          </Typography>

          <Typography variant='body2' align='center'>
            Você precisa acessar sua conta para poder agendar neste centro esportivo.
          </Typography>
          <InputButton onClick={() => serverRouter('login')} sx={{ my: 3 }}>
            Entrar
          </InputButton>
        </Box>
      ) : sttPg.tipoAcesso === null ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <LockOutlinedIcon color='primary' sx={{ fontSize: 50, mb: 1 }} />
          <Typography variant='h6' fontWeight='bold' sx={{ mb: 1 }}>
            Centro esportivo privado
          </Typography>
          <Typography variant='body2' align='center' sx={{ mb: 3 }}>
            Você precisa solicitar acesso para agendar neste centro esportivo.
          </Typography>
          <InputText
            label='Forneça informações para sua aprovação'
            placeholder='Digite aqui'
            value={solAcesso}
            onChange={e => setSolAcesso(e.target.value)}
          />

          <InputButton
            onClick={() => actionsCtxEmps.SolicitarAcessoCentroEsportivo(solAcesso)}
            sx={{ mt: 4 }}
            disabled={solAcesso === ''}
          >
            Enviar solicitação
          </InputButton>
        </Box>
      ) : sttPg.tipoAcesso === 'SOLICITADO' ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <LuClipboardPenLine size='50' color='#FF7043' />
          <Typography variant='h6' fontWeight='bold' sx={{ my: 1 }}>
            Acesso Solicitado
          </Typography>
          <Typography variant='body2' align='center'>
            Sua solicitação foi recebida pelo centro esportivo. Aguarde a aprovação.
          </Typography>
          <InputButton onClick={() => serverRouter('back')} sx={{ mt: 2 }} variant='text'>
            Voltar
          </InputButton>
        </Box>
      ) : sttPg.tipoAcesso === 'REVOGADO' || sttPg.tipoAcesso === 'RECUSADO' ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <BlockIcon color='error' sx={{ fontSize: 50 }} />
          <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
            Você não foi autorizado(a)
          </Typography>
          <Typography variant='body2' align='center' sx={{ my: 2 }}>
            Sua solicitação foi recusada ou revogada pelo centro esportivo, você não poderá agendar
            aqui. Caso ache necessário, você pode entrar em contato com os responsáveis e solicitar
            sua autorização novamente.
          </Typography>
          <InputButton onClick={() => serverRouter('back')} variant='text'>
            Voltar
          </InputButton>
        </Box>
      ) : sttPg.tipoAcesso === 'BLOQUEADO' ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <BlockIcon color='error' sx={{ fontSize: 50 }} />
          <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
            Sem autorização
          </Typography>
          <Typography variant='body2' align='center'>
            Você não poderá agendar aqui por decisão única e exclusiva do próprio centro esportivo.
            Entre em contato com ele se você considera um engano
          </Typography>
          <InputButton
            onClick={() => serverRouter('back')}
            variant='text'
            sx={{ width: '20dvw', mt: 2 }}
          >
            <Typography fontWeight='bold'>Voltar</Typography>
          </InputButton>
        </Box>
      ) : sttPg.tipoAcesso === 'DESATIVADO' ? (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={notAgend} alt='Erro inesperado' style={{ width: '100px', height: 'auto' }} />
          <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
            Centro esportivo desativado
          </Typography>
          <Typography variant='body2' align='center' sx={{ my: 2 }}>
            Este centro esportivo está temporariamente desativado e não está aceitando agendamentos.
            Tente novamente mais tarde.
          </Typography>
          <InputButton
            onClick={() =>
              serverRouter(
                'home',
                Services.ReturnLabelURL(userUCtx.usuario.estado, userUCtx.usuario.cidade),
              )
            }
            variant='text'
          >
            Voltar
          </InputButton>
        </Box>
      ) : (
        <Box sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={notAgend} alt='Erro inesperado' style={{ width: '100px', height: 'auto' }} />
          <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
            Erro inesperado
          </Typography>
          <Typography variant='body2' align='center' sx={{ my: 2 }}>
            Houve um erro inesperado ao tentar solicitar acesso. Entre em contato com a central de
            atendimento.
          </Typography>
          <InputButton onClick={() => serverRouter('back')} variant='text'>
            Voltar
          </InputButton>
        </Box>
      )}
    </div>
  )
}
